// extracted by mini-css-extract-plugin
export default {"events":"EventsList_events__XSeVZ","list":"EventsList_list__M5o+m","item":"EventsList_item__LC0Bu","content":"EventsList_content__irrzO"};